const MAX_CAMPAIGN_PRICE = 9_999_999_999.99;

export function validateCampaignPrice(price: string): string | undefined {
  const value = Number(price);
  if (!/^\d+(?:\.\d{1,2})?$/.test(price.trim()) || !Number.isFinite(value) || value > MAX_CAMPAIGN_PRICE) {
    return 'Enter a non-negative price with at most two decimal places, up to 9,999,999,999.99';
  }
}

export function validateCampaignLuxPlusPrice(price: string, luxPlusPrice: string): string | undefined {
  if (!luxPlusPrice.trim()) {
    return;
  }
  const value = Number(luxPlusPrice);
  const standardPrice = Number(price);
  if (
    !/^\d+(?:\.\d{1,2})?$/.test(luxPlusPrice.trim()) ||
    !Number.isFinite(value) ||
    value <= 0 ||
    value > MAX_CAMPAIGN_PRICE
  ) {
    return 'Enter a positive LuxPlus price with at most two decimal places, up to 9,999,999,999.99';
  }
  if (price.trim() && !validateCampaignPrice(price) && value >= standardPrice) {
    return 'LuxPlus price must be lower than the campaign price';
  }
}

export function parseCampaignLuxPlusPrice(value: string): number | null {
  return value.trim() ? Number(value) : null;
}
